import styled from 'styled-components'
import ripple from '../../../styles/animations/ripple'

export const Role = {
  Container: styled.div`
    ${ripple}
    cursor: pointer;
  `,
  Menu: styled.div`
    gap: 15px;
    display: flex;
    flex-direction: column;
    background: ${({ theme }) => theme.colors.secondary};
    box-shadow: -6px 4px 20px 0px rgba(0, 0, 0, 0.25);
    border-radius: 10px;
    padding: 15px;
  `,
  Item: styled.div`
    ${ripple}
    cursor: pointer;
    color: ${({ theme }) => theme.colors.primary};
  `,
}

export const NamePhoto = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  text-transform: capitalize;
  gap: 15px;
  img {
    width: 35px;
    border-radius: 100px;
    height: 35px;
  }
`
